<angular2-multiselect [data]="options" [ngModel]="selectedItems" [settings]="dropdownSettings"
    (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
    (onDeSelectAll)="onDeSelectAll($event)" [formControl]="control">
</angular2-multiselect>
